import styled from 'styled-components';
import { StyledInput } from '../GenericOption/GenericOption.styles';
import { injectTypography } from '../../../utils/injectTypography';
function checkmarkIcon(color) {
    return `url(data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 12.2l4.3 4.2 8.1-10.3" stroke="${color}" fill="none" />
     </svg>`)})`;
}
export const StyledCheckbox = styled(StyledInput).attrs({ type: 'checkbox' }) `
  border-radius: 0;

  /* Checkmark */
  &::before {
    display: block;
    width: 24px;
    height: 24px;

    transform: scale(0);
    transform-origin: 50%;

    transition: transform 0.1s ${(props) => props.theme.easing};

    content: ${(props) => checkmarkIcon(props.theme.colors.form.strong)};
  }

  /* Checkmark checked */
  &:checked::before {
    transform: scale(1);
  }

  /* Checkmark invalid */
  &:invalid::before {
    ${(props) => props.invalid &&
    `content: ${checkmarkIcon(props.theme.colors.form.error)};`}
  }

  /* Checkmark disabled */
  &:disabled::before {
    content: ${(props) => checkmarkIcon(props.theme.colors.form.muted.primary)};
  }
`;
export const StyledOptionalText = styled.span `
  display: inline-block;

  color: ${(props) => props.theme.colors.form.secondary};

  ${(props) => injectTypography(props, 'copy2')}
`;
//# sourceMappingURL=Checkbox.styles.js.map